export const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const ONBOARDING_URL = process.env.REACT_APP_ONBOARDING_BACKEND_URL;